// The studio pictures of your cars (public/brand/cars/<name>.jpg), used on the phone's Collection
// cards and at the top of each car's page.
//
// A picture is matched to a car by its registration number (spaces and dashes ignored), so
// "AX52 YKG" finds ax52ykg.jpg. A few cars are matched another way, listed below.
// To add a car: drop <registration in lower case>.jpg into public/brand/cars/ and add its name to
// BY_REGISTRATION.

const BY_REGISTRATION = [
  '2283a', '2640a', '449a', 'ax52ykg', 'eax372', 'etp005', 'kam894', 'kpw501', 'kt867', 'kyz006',
  'nxp526', 'nyy230', 'ppm277', 'rt588', 's446rkw', 'the021', 'vs505', 'wl402',
];

// Cars matched by what they are (words in the brand, model, variant and registration, plus the year).
const BY_DESCRIPTION = [
  { file: 'jaguar-e-type', test: (t) => t.includes('jaguar') && t.includes('type') },
  { file: 'rr-townley',    test: (t, year) => t.includes('townley') || (t.includes('range') && t.includes('rover') && year === 1986) },
  { file: 'vs505',         test: (t) => t.includes('audi') && t.includes('quattro') },
];

const squash = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
const words = (s) => String(s || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);

export const carPhotoFor = (v) => {
  if (!v) return null;
  const reg = squash(v.registration_number);
  if (reg && BY_REGISTRATION.includes(reg)) return `/brand/cars/${reg}.jpg`;
  const text = words([v.brand, v.model, v.variant, v.registration_number].join(' '));
  const hit = BY_DESCRIPTION.find(r => r.test(text, Number(v.year)));
  return hit ? `/brand/cars/${hit.file}.jpg` : null;
};
